import { ActivityIndicator, View } from "react-native"
import { useLocalSearchParams } from "expo-router"

import { trpc } from "@src/utils"
import { ar } from "@src/i18n"
import { Header, Text, SupplierForm } from "@src/components"

export default function EditSupplier() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)

  const supplier = trpc.suppliers.get.useQuery({ id })

  if (supplier.isLoading) {
    return (
      <>
        <Header title={ar.editSupplier} />
        <ActivityIndicator className="mt-4" />
      </>
    )
  }

  if (!supplier.data) {
    return (
      <>
        <Header title={ar.editSupplier} />
        <View className="flex-1 justify-center items-center">
          <Text className="text-gray-500">{ar.supplierNotFound}</Text>
        </View>
      </>
    )
  }

  return (
    <>
      <Header title={ar.editSupplier} />
      <SupplierForm id={id} />
    </>
  )
}
